import { render, staticRenderFns } from "./ViewPartnerProfitOrder.vue?vue&type=template&id=0cfa39fd&scoped=true&"
import script from "./ViewPartnerProfitOrder.vue?vue&type=script&lang=js&"
export * from "./ViewPartnerProfitOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa39fd",
  null
  
)

export default component.exports